import React, { useRef, useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { pickNotNumberAllowDecimal } from '../../../actions/reg';
import { ApiPort } from '../../../actions/TLCAPI';
import { createBonusApplications, HandleManalPreBonuseErrorModule } from '../../../data/wallet';
import PromotionOneWalletModal from '../../../pages/PromotionOneWalletModal';
import { Col, Modal, Input, Button } from 'antd';
import { post } from '../../../actions/TlcRequest';

function ReloadBonusApplicationForm({visible, onClose, bonus, ...props}) {
    const [memberInfo, setMemberInfo] = useState(
        JSON.parse(localStorage.getItem("memberInfo")) || {}
    );
    const [errorMessage, setErrorMessage] = useState("");
    const [apiError, setApiError] = useState({});
    const [isFetching, setIsFetching] = useState(false); // 處理 bonus API 的 loading 狀態
    const [showErorModal, setShowErrorModal] = useState(false);
    const [userInputAmount, setUserInputAmount] = useState(0);
    const [gottenAmount, setGottenAmount] = useState(0);
    const [neededTurnover, setNeededTurnover] = useState(0);
    const debounceTimeout = useRef(null); // 儲存 debounce 的計時器
    const userCenter = useSelector((state) => state.userCenter);
    console.log("userCenteruserCenter", userCenter);
    useEffect(() => {
        console.log("Member Info:", memberInfo);
    }, [memberInfo?.userName]);


    // UseEffect with internal setTimeout to debounce:
    useEffect(() => {
        console.log("userInputAmount", userInputAmount);
        if (!userInputAmount) {
        setGottenAmount(0);
        setNeededTurnover(0);
        return;
        }

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        const timer = setTimeout(() => {
        fetchBonusData(userInputAmount);
        }, 500);
    
        // Cleanup the timer on unmount or if userInputAmount changes
        return () => clearTimeout(timer);
    }, [userInputAmount])

    // 清除 debounce 計時器
    useEffect(() => {
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            setUserInputAmount(0);
            setErrorMessage("");
            setGottenAmount(0);
            setNeededTurnover(0);
        };
    }, []);

    // 處理輸入金額
    const handleChange = (e) => {
        const value = e.target.value.replace(
            pickNotNumberAllowDecimal,
            ""
        ); // 清除非法字符

        setUserInputAmount(value);
        setErrorMessage("");

        // if (debounceTimeout.current) {
        //     clearTimeout(debounceTimeout.current);
        // }

        // // 設置新的 debounce 計時器
        // debounceTimeout.current = setTimeout(() => {
        //     if (value) {
        //         fetchBonusData(value); // 調用 API
        //     } else {
        //         setGottenAmount(0);
        //         setNeededTurnover(0);
        //     }
        // }, 500); // 500ms 的 debounce 時間
    };

    // 調用 API 獲取 bonus 和 turnover 數字
    const fetchBonusData = async (value) => {
        console.log("fetchBonusData", value);
        if (Number(value) === 0) return;
        setIsFetching(true); // 啟用 loading

        try {
            const params = {
                bonusMode: "Deposit",
                bonusId: bonus?.bonusData?.id,
                bonusRuleGroupId: bonus?.bonusData?.groupID,
                amount: Number(value),
                wallet: bonus?.bonusData?.account,
                // BonusAmount: Number(value),
                memberBalance:
                    userCenter?.balanceInfo?.MAIN?.balance || 0,
            };
            const res = await post(ApiPort.POSTCalculateBonus, params);

            if (res?.isSuccess && res?.result) {
                const {
                    bonusGiven = 0,
                    turnoverRequire = 0,
                    errorMessage = "",
                } = res.result;
                setGottenAmount(errorMessage ? 0 : bonusGiven); // 設置 bonus
                setNeededTurnover(errorMessage ? 0 : turnoverRequire); // 設置 turnover
                setErrorMessage(errorMessage); // 設置 API 返回的錯誤訊息
            } else {
                if (res?.result?.errorMessage !== "") {
                    setErrorMessage(res?.result?.errorMessage);
                }
            }
        } catch (apiError) {
            console.error("API Error:", apiError);
        } finally {
            setIsFetching(false); // 關閉 loading
        }
    };

    const checkIsDisabled = () => {
        return (
            userInputAmount === 0 || isFetching || errorMessage !== ""
        );
    };

    const handleSubmitForm = async () => {
        setIsFetching(true);
        let postData = {
            amount: userInputAmount,
            bonusId: bonus?.bonusData?.id,
            bonusGroupId: bonus?.bonusData?.bonusGroupId,
            targetWallet: bonus?.bonusData?.account,
        };
        let resp = await createBonusApplications(postData);
        console.log(
            "handleSubmitFormEnrollmentWithFormForManualItem",
            resp
        );
        setIsFetching(false);
        if (!resp.isSuccess || !resp?.result?.bonusResult?.message) {
            let errorType = HandleManalPreBonuseErrorModule(
                resp?.result?.errorCode
            );
            if (errorType?.showModal) {
                console.log("errorType", errorType);
                setShowErrorModal(true);
                setApiError(errorType?.config);
            } else {
                props?.showToastAfterFailure();
            }
        } else {
            setShowErrorModal(false);
            setApiError({});
            onClose();
            props?.showToastAfterSuccess();
        }
    };

    return (
        <Modal visible={visible} footer={null} closable={false}>
        <div className="PromotionManualPromotionApplicationForm">
            <span
                onClick={() => {
                    onClose();
                    setUserInputAmount(0);
                    setErrorMessage("");
                    setGottenAmount(0);
                    setNeededTurnover(0);
                }}
                style={{
                    position: "absolute",
                    top: "15px",
                    right: "-3px",
                    zIndex: "10",
                    cursor: "pointer",
                }}
            >
                <img
                    src="/vn/img/1wallet/00/ModalCloseIcon.svg"
                    alt="Close Icon"
                />
            </span>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        marginTop: "55px",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Đăng ký Khuyến mãi
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    ELITE - THƯỞNG NẠP LẠI - 50% TẠI TRÒ CHƠI!
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Số Tiền Đăng Ký
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-account"
                    defaultValue={userInputAmount}
                    value={userInputAmount}
                    onChange={handleChange}
                />
                {errorMessage !== "" && (
                    <div
                        style={{
                            color: "#EB2121",
                            marginTop: "5px",
                            fontSize: "12px",
                            fontWeight: "400",
                            lineHeight: "16px",
                        }}
                    >
                        {errorMessage}
                    </div>
                )}
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Thưởng có sẵn
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-email"
                    defaultValue={0}
                    value={gottenAmount}
                    disabled
                />
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Doanh thu yêu cầu
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-phone"
                    defaultValue={0}
                    value={neededTurnover}
                    disabled
                />
            </Col>
            <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                <Button
                    style={{
                        color: checkIsDisabled()
                            ? "#999999"
                            : "#FFFFFF",
                        backgroundColor: checkIsDisabled()
                            ? "#E5E5E5"
                            : "#00A6FF",
                    }}
                    className="PromotionManualPromotionApplicationForm-submit"
                    disabled={checkIsDisabled()}
                    onClick={() => {
                        if (!checkIsDisabled()) {
                            Pushgtagdata(
                                "Promotion",
                                "Submit Promotion Form",
                                "Promotion_S_Application",
                                false,
                                [
                                    {
                                        customVariableKey: `Promotion_S_Application_PromoName_PrmoID`,
                                        customVariableValue: `${bonus?.promoTitle}_${bonus?.promoId}`,
                                    },
                                ]
                            );
                            handleSubmitForm();
                        }
                    }}
                >
                    Gửi
                </Button>
            </Col>
            <PromotionOneWalletModal
                isVisible={showErorModal}
                config={apiError}
                onClose={() => {
                    setShowErrorModal(false);
                    setApiError({});
                }}
            />
        </div>
        </Modal>
    );
}

export default ReloadBonusApplicationForm